export const index = {
	HOME: 0,
	MYCHALLENGE: 1,
	OTHERS: 2,
}